/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from "react";
import { useDimensions } from "../../context";
export const TABLET_MAX_WIDTH = 900;
export const MOBILE_MAX_WIDTH = 768;
export const useMedia = (query) => {
    const [isMatch, setIsMatch] = React.useState(false);
    React.useEffect(() => {
        const onChange = () => setIsMatch(mediaQueryList.matches);
        const mediaQueryList = window.matchMedia(query);
        const useNewListener = typeof mediaQueryList.addEventListener !== "undefined";
        if (useNewListener) {
            mediaQueryList.addEventListener("change", onChange);
        }
        else {
            mediaQueryList.addListener(onChange);
        }
        setIsMatch(mediaQueryList.matches);
        return () => {
            if (useNewListener) {
                mediaQueryList.removeEventListener("change", onChange);
            }
            else {
                mediaQueryList.removeListener(onChange);
            }
        };
    }, []);
    return isMatch;
};
export const useIsMobileDevice = () => useMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`);
export const useIsTabletDevice = () => useMedia(`(max-width: ${TABLET_MAX_WIDTH}px)`);
export const useIsContentUnderWidth = (maxWidth = TABLET_MAX_WIDTH) => {
    const { width } = useDimensions();
    return React.useMemo(() => {
        return width !== null && width <= maxWidth;
    }, [width, maxWidth]);
};
export const useIsContentMobile = () => {
    return useIsContentUnderWidth(MOBILE_MAX_WIDTH);
};
export const useIsContentTablet = () => {
    return useIsContentUnderWidth(TABLET_MAX_WIDTH);
};
